var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',{staticClass:"card-header is-flex is-flex-direction-column"},[_c('div',{staticClass:"card-header-title"},[_c('div',{staticClass:"name mr-1"},[_vm._v(_vm._s(_vm.$t(_vm.name)))]),(_vm.shouldBeDisplayed)?_c('div',{staticClass:"unit"},[_vm._v("["+_vm._s(_vm.$t(_vm.unit))+"]")]):_vm._e()]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }